import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/shared/lib/hooks";
import {
  selectAuthToken,
  selectCurrentUser,
  setCredentials,
  useGetCurrentUserQuery,
} from "@/features/auth";
import { Loader } from "@/shared/ui";

import styles from "./appLayout.module.scss";
import { Sidebar } from "@/widgets/sidebar";

export const AppLayout = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(selectAuthToken);
  const currentUser = useAppSelector(selectCurrentUser);
  const skipGetUser = !token || !!currentUser;

  const { data, isError, isFetching, isUninitialized } = useGetCurrentUserQuery(
    undefined,
    {
      skip: skipGetUser,
    },
  );

  useEffect(() => {
    if (data?.user && token && !currentUser) {
      dispatch(setCredentials({ user: data.user, token }));
    }
  }, [data, token, currentUser, dispatch]);

  // После обновления страницы в памяти нет пользователя, только токен.
  // Ждём ответ /api/auth/user. Если он уже разобран, держим загрузку
  // один кадр, пока роль не попадёт в хранилище.
  if (
    token &&
    !currentUser &&
    !isError &&
    (isUninitialized || isFetching || !!data?.user)
  ) {
    return <Loader />;
  }

  return (
    <div className={styles.appLayout}>
      <Sidebar />
      <main className={styles.appMain}>
        <Outlet />
      </main>
    </div>
  );
};
